import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sf-modal-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-danger tw-text-center" }, " You have logged in as a different user ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " You have been logged in as a different user while completing the test. Please login again to save your results. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-danger tw-text-center" }, "Logged Out", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " You have been logged out while completing the test. Please login again to save your results. ", -1)
const _hoisted_6 = { class: "tw-text-center" }
const _hoisted_7 = { class: "tw-mx-auto tw-text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-danger tw-text-center" }, "Deadline Expired", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, " While you were completing this test the deadline to complete it has expired. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-danger tw-text-center" }, "Error Saving", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "There was an error saving your results", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " please check your connection and try saving again. ", -1)
const _hoisted_13 = { class: "tw-mt-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-danger" }, "Error Saving", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "There was an error saving your results", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, " Try to save your results again, if the error continues please report it to your teacher. ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " Remember to tell them the day and time when this happened. ", -1)
const _hoisted_18 = { class: "tw-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_ctx.status < 0)
    ? (_openBlock(), _createBlock(_component_ModalDialog, {
        key: 0,
        show: true,
        "can-close": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.errorMessage == 'loggedOut' || _ctx.errorMessage == 'userIdConflict')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.errorMessage == 'userIdConflict')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_2,
                        _hoisted_3
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_4,
                        _hoisted_5
                      ], 64)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_LoginForm, {
                        screen: "login",
                        onLoggedin: _ctx.onSaveAgain
                      }, null, 8, ["onLoggedin"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: "",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onShowResults && _ctx.onShowResults(...args)), ["prevent"]))
                    }, " or show test results without saving ")
                  ])
                ], 64))
              : (_ctx.errorMessage == 'testDeadlineExpired')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_8,
                    _hoisted_9
                  ], 64))
                : (_ctx.status == -1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_10,
                      _hoisted_11,
                      _hoisted_12,
                      _createElementVNode("p", _hoisted_13, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSaveAgain && _ctx.onSaveAgain(...args)), ["prevent"])),
                          class: "sf-btn-primary"
                        }, " Save Again ")
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onShowResults && _ctx.onShowResults(...args)), ["prevent"]))
                        }, " or show test results without saving ")
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _createElementVNode("p", _hoisted_18, [
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSaveAgain && _ctx.onSaveAgain(...args)), ["prevent"])),
                          class: "sf-btn-primary"
                        }, " Save Again ")
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onShowResults && _ctx.onShowResults(...args)), ["prevent"]))
                        }, " or show test results without saving ")
                      ])
                    ], 64))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}